<template>
  <div class="my-12 py-12">
    <h2
      class="display-1 my-md-3 my-lg-3 my-xl-3 pb-5 font-weight-bold"
    >¿Qué puede hacer MerloCode por ti y por tus clientes?</h2>
    <v-row
      no-gutters
      class="flex-column flex-md-row flex-lg-row flex-xl-row justify-lg-space-between justify-md-space-between"
    >
      <v-col
        md="6"
        lg="6"
        xl="6"
        class="mb-xs-4 mb-sm-4 mb-md-0 mb-lg-0 mb-xl-0"
      >
        <v-card
          outlined
          class="primary-border my-3 mr-md-3 mr-lg-3 mr-xl-3 max-height"
        >
          <div class="flex-column justify-space-between mx-3">
            <v-container class="mx-1" style="height: 12em;">
              <div class="primary-text font-weight-bold">
                <h3 class="headline my-md-3 my-lg-3 my-xl-3 pb-5 font-italic">
                  Para ti
                </h3>
              </div>
              <div class="mb-5 body-1">
                Podrás crear tu menú con alérgenos, características aplicables
                para los productos, asignar mesas y mucho más desde tu
                aplicación de administrador.
              </div>
            </v-container>

            <div
              v-for="(service, i) in services.owner"
              :key="i"
              class="max-height"
            >
              <v-card-title>{{ service.title.es }}</v-card-title>
              <v-card-text class="body-2">
                {{ service.description.es }}
              </v-card-text>
            </div>
          </div>
        </v-card>
      </v-col>

      <v-col md="6" lg="6" xl="6">
        <v-card
          outlined
          class="primary-border my-3 ml-md-3 ml-lg-3 ml-xl-3 max-height"
        >
          <div class="flex-column justify-space-between mx-3">
            <v-container class="mx-1" style="height: 12em;">
              <div class="primary-text font-weight-bold">
                <h3 class="headline my-md-3 my-lg-3 my-xl-3 pb-5 font-italic">
                  Para tu cliente
                </h3>
              </div>
              <div class="mb-5 body-1">
                Se acabó que esperen para realizar pedidos. Tu cliente sólo
                tiene que escanear el QR en su mesa y pedir lo que quiera desde
                el menú, pudiendo pagar desde la mesa.
              </div>
            </v-container>

            <div
              v-for="(service, i) in services.customer"
              :key="i"
              class="max-height"
            >
              <v-card-title>{{ service.title.es }}</v-card-title>
              <v-card-text class="body-2">
                {{ service.description.es }}
              </v-card-text>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Services",
  data: () => {
    return {
      services: {
        owner: [
          {
            title: { es: "Actualiza tu menú fácilmente" },
            description: {
              es:
                "Con la aplicación de administrador puedes añadir categorías, productos y sus características cómoda y rápidamente. Realiza cambios y publícalos al instante.",
            },
          },
          {
            title: { es: "Crea opciones para los productos" },
            description: {
              es:
                "Tu café puede ser con leche, con bebida de soja, avellana, coco... Añade a tus productos las opciones necesarias y que éstas modifiquen el precio de producto en consecuencia.",
            },
          },
          {
            title: { es: "Realiza un seguimiento de tus pedidos" },
            description: {
              es:
                "Podrás observar en cualquier momento en qué estado se encuentran los pedidos, desde pedido hasta entregado.",
            },
          },
          {
            title: { es: "Atiende más rápido y mejor a tus clientes" },
            description: {
              es:
                "Evitarás malentendidos, olvidos, despistes gracias a tener todos tus pedidos en la pantalla.",
            },
          },
          {
            title: { es: "Aumenta la rotación en las mesas" },
            description: {
              es:
                "Evita los tiempos muertos, tus clientes podrán pedir y pagar sin esperar a ser atendidos.",
            },
          },
        ],

        customer: [
          {
            title: { es: "Consultar el menú desde la mesa" },
            description: {
              es:
                "Los locales que disponen de MerloCode tienen el menú disponible en la mesa para que puedan consultarlo siempre actualizado.",
            },
          },
          {
            title: { es: "Pedir desde la mesa" },
            description: {
              es:
                "En cuanto escanea el código QR en su mesa los camareros ya sabrán dónde atender al cliente. Sin esperar colas ni a que alguien esté disponible, consulta el menú y pide lo que quiera, como quiera.",
            },
          },
          {
            title: { es: "Avisa al camarero desde la mesa" },
            description: {
              es:
                "MerloCode pone a disposición de tu cliente una vía de comunicación alternativa para cuando la vía digital no sea suficiente.",
            },
          },
          {
            title: { es: "Pagar como quiera" },
            description: {
              es:
                "Desde el menú puede realizar el pago como más le convenga escogiendo una de las opciones disponibles.",
            },
          },
          {
            title: { es: "Hacer el pedido a medida" },
            description: {
              es:
                "Tu cliente puede añadir un comentario en cada producto de su pedido para asegurar una comunicación perfecta.",
            },
          },
        ],
      },
    };
  },
};
</script>

<style>
.primary-border {
  border-color: #f79406 !important;
}
.primary-text {
  color: #f79406;
}
.max-height {
  height: 100%;
}
</style>
